import { isValidTeamPhone } from '@/lib/teamPhone';

/** Strip to digits; map common `+61` mobile/landline input to leading `0` local form. */
export function normalizeAustralianPhoneToLocal(raw: string): string | null {
  const d = raw.replace(/\D/g, '');
  if (!d) return null;
  if (d.startsWith('61') && d.length === 11) {
    return `0${d.slice(2)}`;
  }
  if (d.startsWith('0') && d.length === 10) {
    return d;
  }
  return null;
}

/**
 * Australian mobile (`04`), landline (`02`/`03`/`07`/`08`), or `1300`/`1800`.
 * Also accepts the national number without the trunk `0`, and a leading `+61`.
 */
export function isValidAustralianPhone(raw: string): boolean {
  return isValidTeamPhone(raw, 'AU');
}

/** 10-digit local form for API (e.g. `0412345678`). */
export function phoneForContactApi(raw: string): string {
  return normalizeAustralianPhoneToLocal(raw) ?? raw.replace(/\D/g, '');
}
